import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=2839f8a7&scoped=true&"
import script from "./Discussion.vue?vue&type=script&lang=ts&"
export * from "./Discussion.vue?vue&type=script&lang=ts&"
import style0 from "./Discussion.vue?vue&type=style&index=0&id=2839f8a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2839f8a7",
  null
  
)

export default component.exports